type Listener = () => void

interface OpenState {
  id: number
  group?: string
}

let counter = 1
let current: OpenState | null = null
let lastCloseAt = 0
let lastCloseGroup: string | undefined
const listeners = new Set<Listener>()

const zoneStores = new Map<string, Map<string, () => DOMRect | null>>()
const zoneListeners = new Map<string, Set<Listener>>()

export function nextHoverId(): number {
  counter += 1
  return counter
}

export function claimActive(state: OpenState): void {
  current = state
  listeners.forEach((l) => l())
}

export function releaseActive(id: number): void {
  if (current && current.id === id) {
    lastCloseGroup = current.group
    current = null
    lastCloseAt = Date.now()
    listeners.forEach((l) => l())
  }
}

export function getActive(): OpenState | null {
  return current
}

export function getLastCloseAt(): number {
  return lastCloseAt
}

export function isGroupWarm(group: string | undefined, withinMs = 120): boolean {
  if (!group) return false
  if (current && current.group === group) return true
  if (lastCloseGroup === group && Date.now() - lastCloseAt < withinMs) return true
  return false
}

export function subscribeActive(l: Listener): () => void {
  listeners.add(l)
  return () => listeners.delete(l)
}

export function registerAvoidZone(group: string, id: string, getter: () => DOMRect | null): () => void {
  let bucket = zoneStores.get(group)
  if (!bucket) {
    bucket = new Map()
    zoneStores.set(group, bucket)
  }
  bucket.set(id, getter)
  zoneListeners.get(group)?.forEach((l) => l())
  return () => {
    const b = zoneStores.get(group)
    if (!b) return
    b.delete(id)
    if (b.size === 0) zoneStores.delete(group)
    zoneListeners.get(group)?.forEach((l) => l())
  }
}

export function collectAvoidZones(group: string | undefined, excludeId?: string): DOMRect[] {
  if (!group) return []
  const bucket = zoneStores.get(group)
  if (!bucket) return []
  const rects: DOMRect[] = []
  bucket.forEach((getter, id) => {
    if (excludeId && id === excludeId) return
    const rect = getter()
    if (rect) rects.push(rect)
  })
  return rects
}
